query ListStaffMembers {
  result: StreamToolsListStaffMembers {
    mode
    callerListed
    members {
      accountId
      email
      addedBy
      addedByEmail
      createdAt
      isYou
    }
  }
}
